export const INVITE_USER = 'INVITE_USER'
export const DELETE_ORGANIZATION_USER = 'DELETE_ORGANIZATION_USER'
export const RESEND_INVITE = 'RESEND_INVITE'
export const DELETE_INVITE = 'DELETE_INVITE'
export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION'
